import { Button, Card, Col, Form, Input, message, Popconfirm, Row, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addExpenseProject, deleteExpenseProject, getAllExpenseProject, updateExpenseProject } from '../../redux/rtk/features/expenseProject/expenseProjectSlice';
import PageTitle from '../page-header/PageHeader';

const ExpenseProject = () => {
    const { Title } = Typography;

    const [editingProject, setEditingProject] = useState(null);
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { list, loading } = useSelector((state) => state.expenseProject);

    useEffect(() => {
        dispatch(getAllExpenseProject());
    }, [dispatch]);

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            if (editingProject) {
                // Update existing project
                const result = await dispatch(
                    updateExpenseProject({ id: editingProject.id, values })
                ).unwrap();
                if (result.message === 'success') {
                    dispatch(getAllExpenseProject());
                } else {
                    message.error('Error updating project!');
                }
            } else {
                // Add new project
                const result = await dispatch(addExpenseProject(values)).unwrap();
                if (result.message === 'success') {
                    dispatch(getAllExpenseProject());
                } else {
                    message.error('Error adding project!');
                }
            }
            setEditingProject(null);
        } catch (error) {
            console.error('Validation failed or API error:', error);
            message.error('Failed to add or update project!');
        }
    };

    // Handle deletion
    const handleDelete = async (id) => {
        try {
            const result = await dispatch(deleteExpenseProject(id)).unwrap();
            if (result?.message === 'success') {
                dispatch(getAllExpenseProject());
            } else {
            }
        } catch (error) {
            console.error('Delete API error:', error);
        }
    };

    // Table columns
    const columns = [
        {
            title: 'Project',
            dataIndex: 'name',
            key: 'name',
        },

        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
                <>
                    <Button type="link" onClick={() => {
                        setEditingProject(record);
                        form.setFieldsValue(record);
                    }
                    }>
                        Edit
                    </Button>
                    <Popconfirm
                        title="Are you sure you want to delete this project?"
                        onConfirm={() => handleDelete(record.id)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button type="link" danger>
                            Delete
                        </Button>
                    </Popconfirm>
                </>
            ),
        },
    ];

    return (
        <div>
            <PageTitle title='Back' />
            <Row gutter={16} className='mt-2'>
                <Col span={8}>
                    <Card title={editingProject ? 'Edit Project' : 'Add Project'}>
                        <Form
                            form={form}
                            style={{ marginBottom: "40px" }}
                            name="project-form"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 14 }}
                            onFinish={handleOk}
                            autoComplete="off"
                        >
                            <Form.Item
                                name="name"
                                label="Project"
                                rules={[{ required: true, message: 'Please enter a project!' }]}
                            >
                                <Input placeholder="Enter project" />
                            </Form.Item>
                            <Button type="primary" block htmlType="submit">
                                {editingProject ? 'Update Project' : 'Add Project'}
                            </Button>
                        </Form>
                    </Card>
                </Col>
                <Col span={16}>
                    <Card title="Project List">
                        <Table
                            dataSource={list}
                            columns={columns}
                            rowKey="id"
                            loading={loading}
                            style={{ marginTop: 0 }}
                        />
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default ExpenseProject;
